import { useShortDate } from './ShortDate';

export const Date = ({ date, showYear }) => {
  const { getShortDateString } = useShortDate();

  if (!date) return null;

  return getShortDateString({ date, showYear });
};
